var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.934 17.34a.906.906 0 00.644-.27l7.406-7.406a.912.912 0 00.305-.668c0-.246-.105-.469-.305-.668L13.625.968c-.234-.222-.457-.316-.691-.316a.86.86 0 00-.88.868c0 .234.083.468.247.632L15.113 5l3.54 3.258-2.626-.153H1.59c-.516 0-.88.375-.88.891 0 .527.364.89.88.89h14.437l2.637-.152-3.55 3.258-2.813 2.86c-.164.152-.246.386-.246.632 0 .493.386.856.879.856z"
  })));
}

export default SvgArrow;